// extracted by mini-css-extract-plugin
export default {"right_menu":"RightClickPopView_right_menu__-zqeG","right_text":"RightClickPopView_right_text__e3MhH"};